import Vue from 'vue'
// 自适应
import '@/utils/rem.js'

import App from './App.vue'
// router
import router from './router/index.js'
import store from './store/index.js'
import 'vant/lib/index.css'
import '@/utils/import-part-of-vant.js'
// import 'video.js/dist/video-js.css'
import '@/css/index.scss'
import VConsole from 'vconsole'
// import 'https://supaur-jetour.oss-cn-hangzhou.aliyuncs.com/sit/fe-hybrid-h5/sdk/flutter-bridge.js'

// import notify from '@/components/price-notify.vue'
// import { DatePicker } from 'element-ui'

// if (process.env.API_ENV === 'test') {
//   const vConsole = new VConsole()
//   Vue.use(vConsole)
// }
// const vConsole = new VConsole()
// Vue.use(vConsole)
if (process.env.API_ENV === 'test') {
  const vConsole = new VConsole()
  Vue.use(vConsole)
  require('./axb-record-test.js')
} else {
  require('./axb-record-prod.js')
}

AXB_RECORD('CXT')
Vue.config.productionTip = false

// Vue.prototype.$notifyPop = function () {
//   let Notify = Vue.extend(notify)
//   let notifyIns = new Notify()
//   let component = notifyIns.$mount()
//   document.getElementById('app').appendChild(component.$el)
// }
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app')
